import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'EDL-AUTH-USERNAME': environment.api_username,
//     'EDL-AUTH-PASSWORD':  environment.api_password
//   })
// }

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  SERVER_URL= environment.backend_server;

  constructor(
    public http:HttpClient,
    public router:Router
    ) { }


    getInfoHints(data:any){
  
      // const urlUsed = `${this.SERVER_URL}/api/fortesting/testing.php`;
      const urlUsed = `${this.SERVER_URL}/info-hints/load`;
     
      return this.http.post<any>(urlUsed, data);
    }


  private auth_key = new BehaviorSubject([]);
  getAuthKey= this.auth_key.asObservable();

  setAuthKey(auth_key:any) {
    this.auth_key.next(auth_key)
   
  }

  
  private user_data = new BehaviorSubject([]);
  getUserData= this.user_data.asObservable();

  setUserData(user_data:any) {
    this.user_data.next(user_data)
   
  }

  private theme_settings = new BehaviorSubject([]);
  getThemeSettings= this.theme_settings.asObservable();

  setThemeSettings(theme_settings:any) {
    this.theme_settings.next(theme_settings)
   
  }

  private crumbs = new BehaviorSubject([]);
  getMenuCrumbs= this.crumbs.asObservable();

  setMenuCrumbs(crumbs:any) {
    this.crumbs.next(crumbs)
   
  }

  private module_name = new BehaviorSubject('');
  getModuleName= this.module_name.asObservable();

  setModuleName(module_name:any) {
    this.module_name.next(module_name)
   
  }

  


   digitsResult(n, digits) {
    if (digits === undefined) {
        digits = 0;
    }

    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    return (Math.round(n) / multiplicator).toFixed(2);
}




  ////CSV DOWNLOAD

  downloadFile(data, filename='data') {
    
    let csvData = this.ConvertToCSV(data);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray) {

     let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
     let str="";
     let row = "";

     var headerList = Object.keys(objArray[0]);

     for (let index in headerList) {
         row += headerList[index] + ',';
     }

     row = row.slice(0, -1);
     str += row + '\r\n';
     
     for (let i = 0; i < array.length; i++) {
         var line='';
      

         for (let index in headerList) {

            let head = headerList[index];
 
            line += '' + array[i][head] +',';
          
           
         }

   

         str += line + '\r\n';

     }


     return str;
  }


  /// ENCRYPTION ///////////

  encrypt(keys, value){

    // var salt = CryptoJS.lib.WordArray.random(256);
    // var iv = CryptoJS.lib.WordArray.random(16);

    var auth_key_count= keys.length;
    var key_count_half= (keys.length)/2;

    var first_string = keys.substring(0, key_count_half);
    var second_string = keys.substring(key_count_half, auth_key_count);
    
    var ivkey=second_string+first_string;
    var saltkey=second_string+first_string+keys+first_string;

    var salt = CryptoJS.enc.Hex.parse(saltkey);
    var iv =  CryptoJS.enc.Hex.parse(ivkey);

    
    var key = CryptoJS.PBKDF2(keys, salt, { hasher: CryptoJS.algo.SHA512, keySize: 64/8, iterations: 999 });

    var encrypted = CryptoJS.AES.encrypt(value, key, {iv: iv});

    // var data = {
    //     data : CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
    //     salt : CryptoJS.enc.Hex.stringify(salt),
    //     iv : CryptoJS.enc.Hex.stringify(iv)    
    // }

    var data = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

    // console.log("ENC DATA",data)
    

    return data;

  }

  decrypt(keys, value){

    var encrypted = value;

    var auth_key_count= keys.length;
    var key_count_half= (keys.length)/2;

    var first_string = keys.substring(0, key_count_half);
    var second_string = keys.substring(key_count_half, auth_key_count);
    
    var ivkey=second_string+first_string;
    var saltkey=second_string+first_string+keys+first_string;
   
    
    var salt =  CryptoJS.enc.Hex.parse(saltkey);

    var iv = CryptoJS.enc.Hex.parse(ivkey); 
    
    
    var key = CryptoJS.PBKDF2(keys, salt, { hasher: CryptoJS.algo.SHA512, keySize: 64/8, iterations: 999});

    var decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv});

    try{  
       var data= decrypted.toString(CryptoJS.enc.Utf8);

       return JSON.parse(data);
    
    } catch (err){  
      
      var data_err ={
        err:2,
        status:err.name,
        messages:err.message,
        custom_message:"Invalid: Data Received!"

      }

      return data_err;
    }

    // var data= decrypted.toString(CryptoJS.enc.Utf8);

    
  }



}
